import {AnyLinkType} from 'shared/pretty-easy-navigation/models';

export const TrainerMenu: AnyLinkType[] = [
    {
        type: 'link',
        label: 'navigation.compass',
        link: '/boussole',
    },
    {
        type: 'linkGroup',
        label: 'navigation.contents',
        links: [
            {
                type: 'link',
                label: 'navigation.ressources_supplementaires',
                link: '/further/ressources-partenaires-inclusive',
            },
            {
                type: 'accordionLinkGroup',
                label: 'navigation.lessons_group',
                links: [
                    {
                        type: 'link',
                        label: 'navigation.lessons_community',
                        link: '/lessons/list/search',
                        queryParams: { usage: '4055' },
                    },
                    {
                        type: 'link',
                        label: 'navigation.lessons_autonomy',
                        link: '/lessons/list/search',
                        queryParams: { usage: '4056' },
                    },
                ],
            },
            {
                type: 'accordionLinkGroup',
                label: 'navigation.corpus_group',
                links: [
                    {
                        type: 'link',
                        label: 'navigation.corpus_global',
                        link: '/corpus/11057',
                    },
                    {
                        type: 'link',
                        label: 'navigation.corpus_user',
                        link: '{{USER_CORPUS_LINK}}',
                    },
                ],
            },
        ],
    },
    {
        type: 'linkGroup',
        label: 'navigation.group_management_group',
        links: [
            {
                type: 'accordionLinkGroup',
                label: 'navigation.learner_management_group',
                links: [
                    {
                        type: 'link',
                        label: 'navigation.groups_management',
                        link: '/groups/list/groups',
                    },
                    {
                        type: 'link',
                        label: 'navigation.workgroups_management',
                        link: '/groups/list/workgroups',
                    },
                    {
                        type: 'link',
                        label: 'navigation.learners_management',
                        link: '/groups/list/learners',
                    },
                ],
            },
            {
                type: 'link',
                label: 'navigation.self_assignments',
                link: '/followed/tab/self',
            },
        ],
    },
    {
        type: 'linkGroup',
        label: 'navigation.more_group',
        links: [
            {
                type: 'link',
                label: 'navigation.ressources_supplementaires',
                link: '/further/ressources-supplementaires',
            },
            {
                type: 'accordionLinkGroup',
                label: 'navigation.tools',
                links: [
                    {
                        type: 'link',
                        label: 'navigation.notepad',
                        link: '/notepad/list',
                    },
                    {
                        type: 'link',
                        label: 'navigation.mindmap',
                        link: '/mindmap/list',
                    },
                    {
                        type: 'link',
                        label: 'navigation.bd_tool',
                        link: '/bd-tool/list',
                    },
                ],
            },
        ],
    },
    {
        type: 'link',
        label: 'navigation.legal_notice',
        link: '/informations-legales',
    },
    {
        type: 'link',
        label: 'navigation.contact',
        link: '{{GAR_CONTACT}}',
    },
    {
        type: 'link',
        label: 'navigation.site_map',
        link: '{{SITE_MAP_LINK}}',
    },
];
